import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { POST_SALES_LISTING, SITE_INSPECTION_LISTING, INSPECTION_CREATED } from "./type";

export const getPostSaleListing = (queryObj = null, page = 1) => async (dispatch) => {

  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `?lead_id=${queryObj.leadID}&status=${queryObj.leadStatus}&client_name=${queryObj.clientNameOrPartnerName}&created_on=${queryObj.createdOnDate}&from_date=${queryObj.fromDate}&to_date=${queryObj.toDate}&assigned_to=${queryObj.leadOwnerOrAssignee}&city=${queryObj.city}&zone=${queryObj.zone}&lead_cat=${queryObj.lead_cat}&lcfrom_date=${queryObj.lcfromDate}&lcto_date=${queryObj.lctoDate}&ncfrom_date=${queryObj.ncfromDate}&ncto_date=${queryObj.nctoDate}&page=${page}`;
  }
  
  try {
    const teamName = await JSON.parse(localStorage.getItem("profileDetails"))[0]
      .team_id;
    var teams = await JSON.parse(localStorage.getItem("profileDetails"));
    console.log(teams);
    var teamId = [];
    teams.forEach((team, index) => {
      teamId.push(team.team_id);
    });
    console.log(teamId);
    if (queryObj !== null) {
      filterQuery += `&teamId=${teamId}`;
    }

    const departmentName = await JSON.parse(
      localStorage.getItem("profileDetails")
    )[0].department_id;
    let apiUrl;
    if (departmentName && departmentName === 2) {
          apiUrl = queryObj
        ? `${Config.preSalesList.fetchAllData}${filterQuery}`
        : Config.preSalesList.fetchAllData;
      // if (teamName && teamName === 7) {
      //   apiUrl = queryObj
      //   ? `${Config.preSalesList.type}${filterQuery}`
      //   : Config.preSalesList.type;
      // } else if (teamName && teamName === 9) {
      //   apiUrl = queryObj
      //   ? `${Config.preSalesList.listSupply}${filterQuery}`
      //   : Config.preSalesList.listSupply;
      // } else if (teamName && teamName === 8) {
      //   apiUrl = queryObj
      //   ? `${Config.preSalesList.listApartments}${filterQuery}`
      //   : Config.preSalesList.listApartments;
      // } else {
      //   apiUrl = queryObj
      //   ? `${Config.preSalesList.listAlliance}${filterQuery}`
      //   : Config.preSalesList.listAlliance;
      // }
    }else if(teamName && teamName === 16){
      apiUrl = queryObj
      ? `${Config.preSalesList.listSupply}${filterQuery}`
      : Config.preSalesList.listSupply;
    }else if(teamId && teamId.includes(21)){
      apiUrl = queryObj
          ? `${Config.preSalesList.fetchAllData}${filterQuery}`
          : Config.preSalesList.fetchAllData;
    }

    dispatch({
      type: POST_SALES_LISTING,
      payload: {},
    });

    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}${queryObj === null && `?status=1,2,3,4,5,6,7,8,9,10&teamId=${teamId}&page=${page}`}`
    );

    if (res) {
      const { data } = res;
      const payload = data.response?.data ?? data.data;
      dispatch({
        type: POST_SALES_LISTING,
        payload: payload,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: POST_SALES_LISTING,
      payload: {},
    });
  }
};


export const createSiteInspectionForm = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.postSalesList.createSiteInspectionForm
  );
  if (res?.data?.status === 0 || res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
}

export const inspectionCreated = (request_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    Config.postSalesList.inspectionCreated+"?request_id="+request_id
  );
  if (res) {
    const { data } = res;
    const payload = data.response?.data ?? data.data;
    dispatch({ type: INSPECTION_CREATED, payload: payload });
    return payload;
  }
}

export const viewSiteInspectionForms = (filtersOrLegacyFlag = {}, page = 1) => async (dispatch) => {
  let filters = filtersOrLegacyFlag;
  let pageNum = page;

  if (typeof filtersOrLegacyFlag === "boolean") {
    filters = {};
    pageNum = page;
  }

  const params = new URLSearchParams();
  params.set("page", pageNum);
  params.set("per_page", 15);

  if (filters?.site_name) {
    params.set("site_name", filters.site_name);
  }
  if (filters?.assigned_to) {
    params.set("assigned_to", filters.assigned_to);
  }
  if (filters?.approved_by) {
    params.set("approved_by", filters.approved_by);
  }

  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.postSalesList.viewSiteInspectionForms}?${params.toString()}`
  );
  if (res) {
    const payload = res?.data?.data ?? res?.data?.response?.data;
    dispatch({ type: SITE_INSPECTION_LISTING, payload });
    return payload;
  }
};

export const listSiteInspectionManagers = () => async () => {
  const res = await callWebService(
    callTypes.get,
    "",
    Config.postSalesList.listSiteInspectionManagers
  );
  if (res) {
    const payload = res?.data?.data ?? res?.data?.response?.data;
    return payload?.managers ?? [];
  }
  return [];
};

export const changeSiteInspectionManager = (body) => async () => {
  const res = await callWebService(
    callTypes.post,
    body,
    Config.postSalesList.changeSiteInspectionManager
  );
  if (
    res?.data?.status === 0 ||
    res?.data?.response?.status === true ||
    res?.data?.status === true
  ) {
    return true;
  }
  return false;
};
